<template>
  <div class="area-logada-resultado-container" :style="{ maxHeight: resultadoHeight, minHeight: resultadoMinHeight, marginBottom: resultadoMarginBottom }">
    <modalprotestodetalhe :nrPedidoProtesto="nrPedidoSelecionado" @resposta="respConfirm" v-if="page=='VisualizarPedidoProtesto'"/>
    <modalcertidaodetalhe :nrPedidoCertidao="nrPedidoSelecionado" :certidaoDados="certidaoDetalheSelecionada" @resposta="respConfirm" v-else-if="page=='Certidao'" />
    <modalcancelamentodetalhe :nrPedidoCancelamento="nrPedidoSelecionado" :cancelamentoDados="cancelamentoDetalheSelecionada" @resposta="respConfirm" v-else-if="page=='Cancelamento'" />
    <modalanuenciadetalhe :nrPedidoAnuencia="nrPedidoSelecionado" :anuenciaDados="anuenciaDetalheSelecionada" @resposta="respConfirm" v-else-if="page=='aprovadas'" />
    <b-modal ref="modalMaisOpcoes" id="modal-mais-opcoes" title="Opções protesto" hide-footer hide-header :key="maisOpcoesKey">
      <template #default="{ hide }">
        <div class="modal-mais-opcoes-close" @click="hide()">x</div>
        <h4>Solicitação nº {{ pedidoSelecionado }}</h4>
        <hr class="mb-4" />
        <b-row v-for="(pedaco, index) in acoes" :key="'maisOpcoes_row_' + index">
          <b-col :cols="12 / pedaco.length" v-for="(acao, idx) in pedaco" :key="'maisOpcoes_col_'+idx">
            <b-card 
              class="text-center" 
              :class="!(itemAcao[acao.condicao] == 1 || acao.condicao == 1) ? 'disabled' : ''"
              @click="executaFuncaoAcoes(acao, itemAcao)"
              >
              <b-card-text class="d-flex flex-column align-items-center justify-content-center">
                <font-awesome-icon
                  :icon="acao.icone"
                  :size="acao.tamanho"
                  :title="acao.titulo"
                  :class="acao.cor"
                  />
                <span>{{ acao.titulo }}</span>
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>  
      </template>
    </b-modal>
    <div class="table-resultado-header" v-bind="tableStyleProperties">
      <div v-for="(coluna, idx) in colunas" :key="idx" class="table-resultado-column">
        <div v-if="coluna.sortable" class="table-resultado-sort" :id="coluna.key" @click="sortResult(coluna.key)">
          <div class="sort-icons"></div>
          {{ coluna.label }}
        </div>
        <div v-else :id="coluna.key" v-html="coluna.label" />
      </div>
    </div>
    <div class="table-resultado-body">
      <div v-for="(row, index) in sortedResult" :key="index" class="table-resultado-row" v-bind="tableStyleProperties">
        <div v-for="(coluna, idx) in colunas" :key="idx" :id="coluna.key + '-result-' + index" class="table-resultado-column">
          <div v-if="coluna.key == 'details'" id="details-button" class="table-resultado-detail btn-details" @click="exibir(row)">Detalhes</div>
          <div v-if="coluna.key == 'actions'" id="actions-container" class="table-resultado-detail container-actions">
            <template v-for="(acao, chave) of coluna.acoes">
              <font-awesome-icon
                style="cursor: pointer"
                class="mr-2"
                :key="chave"
                v-if="(row[acao.condicao] == 1 || acao.condicao == 1) && ((row.maisAcoes && chave < 2) || !row.maisAcoes)"
                :icon="acao.icone"
                :size="acao.tamanho"
                :title="acao.titulo"
                :class="acao.cor"
                @click="executaFuncaoAcoes(acao, row)"
              />
            </template>
            <!--
                        <div class="action-item item-show">
                            <font-awesome-icon
                                icon="eye"
                                size="1x"
                                @click="exibir(row)"
                                style="cursor: pointer"
                                title="Visualizar"
                            />
                        </div>
                        -->
            <!-- 
                            <div class="action-item">
                            <div class="recibo-icon"></div>
                        </div>
                        <div class="action-item bg-fill">
                            <font-awesome-icon
                                icon="dollar-sign"
                                size="1x"
                                style="cursor: pointer"
                                title="Pagar"
                            />
                        </div> 
                        -->
          </div>
          <div v-else-if="coluna.exibicao">
            {{ coluna.isCurrency ? currencyFormatter.format(row[coluna.key]) : coluna.isNested ? nestedColumn(row, coluna.key) : coluna.isDate ? dateFormat(row[coluna.key]) : coluna.maskDoc ? documentoFormat(row[coluna.key]) : row[coluna.key] }}
          </div>
          <span v-else>
            {{ coluna.isCurrency ? currencyFormatter.format(row[coluna.key]) : coluna.isNested ? nestedColumn(row, coluna.key) : coluna.isDate ? dateFormat(row[coluna.key]) : coluna.maskDoc ? documentoFormat(row[coluna.key]) : row[coluna.key] }}
            <div class="table-resultado-column-infolet">
              {{ coluna.isCurrency ? currencyFormatter.format(row[coluna.key]) : coluna.isNested ? nestedColumn(row, coluna.key) : row[coluna.key] }}
            </div>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import detailscard from "@/components/arealogada/pesquisa/resultado/details.vue";
// import { title } from "process";
import Vue from "vue";
import modalprotestodetalhe from "@/components/modal/protesto_detalhe";
import modalcertidaodetalhe from "@/components/modal/certidao_detalhe";
import modalcancelamentodetalhe from "@/components/modal/cancelamento_detalhe";
import modalanuenciadetalhe from "@/components/modal/anuencia_detalhe";


export default {
  components: {
    detailscard,
    modalprotestodetalhe,
    modalcertidaodetalhe,
    modalcancelamentodetalhe,
    modalanuenciadetalhe,
  },
  props: {
    colunas: { type: Array, default: [] },
    resultado: { type: Array, default: [] },
    page: String ,
    title: { type: String },
    offsetHeight: { type: String, default: "" },
    detalheAtivo: { type: Boolean, default: false },
  },
  data() {
    return {
      tableStyleProperties: { style: {} },
      sort: { key: "", sorting: "" },
      currencyFormatter: new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }),
      detailCardBgOptions: { azul: "F2F6FE", amarelo: "FEFDF2", verde: "F2FEF6", vermelho: "FEF2F2", branco: "FFFFFF" },
      detailCardBg: "",
      exibirDetalhe: false,
      nrPedidoSelecionado:'',
      certidaoDetalheSelecionada:{},
      cancelamentoDetalheSelecionada:{},
      anuenciaDetalheSelecionada:{},
      maisOpcoesKey: 0,
      itemAcao: {},
    };
  },
  methods: {
    respConfirm(res){
      if (res.respostaFinal == "s") {
        this.exibirDetalhe = false;
        if(this.page === 'VisualizarPedidoProtesto') this.$bvModal.hide("modal-protesto-detalhe");
        else if (this.page === 'Certidao' ) this.$bvModal.hide("modal-certidao-detalhe");
        else if (this.page === 'Cancelamento') this.$bvModal.hide("modal-cancelamento-detalhe");
        else if (this.page === 'aprovadas') this.$bvModal.hide("modal-anuencia-detalhe");
      }
    },
    nestedColumn(row, columnKey) {
      let value;
      let keys = columnKey.split(".");
      for (let k = 0; k < keys.length; k++) {
        if (k == 0) value = row[keys[k]];
        else value = value[keys[k]];
      }
      return value;
    },
    dateFormat(value) {
      if (value !== "" && value !== undefined && value !== null) {
        let date = new Date(value);
        return date.toLocaleDateString("pt-BR", {
          hour: "numeric",
          minute: "numeric",
          year: "numeric",
          month: "numeric",
          day: "numeric",
        });
      }
      return "";
    },
    documentoFormat(string) {
      if (string == null) {
        return '';
      } else {
        let v = string;
        v = v.replace(/\D/g, "");
        if (v.length < 14) { //CPF
          v = v.replace(/(\d{3})(\d)/, "$1.$2")
                  .replace(/(\d{3})(\d)/, "$1.$2")
                  .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
        } else { //CNPJ
          v = v.replace(/^(\d{2})(\d)/, "$1.$2")
                  .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
                  .replace(/\.(\d{3})(\d)/, ".$1/$2")
                  .replace(/(\d{4})(\d)/, "$1-$2");
        }
        return v;
      }
    },
    clearDetailSelection() {
      var elements = document.querySelectorAll(".table-resultado-row.active");
      elements.forEach((element) => {
        element.classList.remove("active");
      });
      let detailCard = document.getElementById("resultado-detail-card");
      if (detailCard !== undefined && detailCard !== null) detailCard.remove();
    },
    exibir(row) {
      if(this.page === 'VisualizarPedidoProtesto') {
        this.nrPedidoSelecionado = row.cd_pedido_protesto;
        this.exibirDetalhe = true;
      }
      else if (this.page === 'Certidao'){
        this.nrPedidoSelecionado = row.cd_pedido;
        this.certidaoDetalheSelecionada = row;
        this.exibirDetalhe = true;
      }
      else if (this.page === 'Cancelamento'){
        this.nrPedidoSelecionado = row.cd_pedido;
        this.cancelamentoDetalheSelecionada = row;
        this.exibirDetalhe = true;
      }
      else if (this.page === 'aprovadas'){
        this.nrPedidoSelecionado = row.cd_anuencia;
        this.anuenciaDetalheSelecionada = row;
        this.exibirDetalhe = true;
      }
      else{
        let clickedRow = event.target.closest(".table-resultado-row");
        if (!clickedRow.classList.contains("active")) {
          this.clearDetailSelection();
          clickedRow.classList.add("active");
          this.detalheAtivo = true;
          this.insertDetailCard(row, clickedRow);
        } else {
          clickedRow.classList.remove("active");
          this.detalheAtivo = false;
          document.getElementById("resultado-detail-card").remove();
        }
      }
    },
    insertDetailCard(row, rowElement) {
      var ComponentClass = Vue.extend(detailscard);
      var detailCardFields = this.detailCardFields(row);
      var status = "";
      if (row.status !== null && row.status !== undefined) {
        if (row.status.nm_status !== null && row.status.nm_status !== undefined) {
          status = row.status.nm_status;
        } else {
          status = row.status;
        }
      } else if (row.cd_status !== null && row.cd_status !== undefined) {
        status = row.cd_status;
      }

      var instance = new ComponentClass({
        propsData: {
          item: row,
          status: status,
          detailCardFields: detailCardFields,
          gridRowProperties: this.tableStyleProperties,
          page: this.page,
          rowWidth: rowElement.offsetWidth,
        },
      });
      instance.$mount();
      rowElement.parentNode.insertBefore(instance.$el, rowElement.nextSibling);
    },
    sortResult(key) {
      if (this.sort.key == key) {
        switch (this.sort.sorting) {
          case "asc":
            document.getElementById(key).classList.remove("sort-asc");
            this.sort.sorting = "desc";
            break;
          case "desc":
            this.clearSort();
            break;
        }
      } else {
        this.clearSort();
        this.sort.key = key;
        this.sort.sorting = "asc";
      }
      if (this.sort.sorting !== "") document.getElementById(key).classList.add("sort-" + this.sort.sorting);
    },
    clearSort() {
      var elements = document.querySelectorAll(".table-resultado-sort");
      elements.forEach((element) => {
        element.classList.remove("sort-asc", "sort-desc");
      });
      this.sort.key = "";
      this.sort.sorting = "";
    },
    setRequesterStructure() {
      return [
        [
          [{ key: "nm_solicitante", label: "Solicitante:" }, { key: "celular_solicitante", label: "Celular:", telephone: true }],
          [{ key: "documento_solicitante", label: "Documento:", maskDoc: true }, { key: "telefone_solicitante", label: "Telefone:", telephone: true }],
          [{ key: "nm_email_solicitante", label: "E-mail:" }],
        ],
        [
          [{ key: "endereco_solicitante", label: "End.:" }, { key: "cep_solicitante", label: "CEP:", zipCode: true }, { key: "cidade_solicitante", label: "Cidade:" }],
          [{ key: "nr_endereco_solicitante", label: "Nº:" }, { key: "bairro_solicitante", label: "Bairro:" }, { key: "uf_solicitante", label: "UF:" }],
          [{ key: "complemento_solicitante", label: "Complemento:" }],
        ],
      ];
    },
    setRegOffStructure() {
      return [
        [
          [{ key: "nome_cartorio", label: "Nome:" }, { key: "documento_cartorio", label: "CNPJ:", maskDoc: true }],
          [{ key: "email_cartorio", label: "E-mail:" }, { key: "telefone_cartorio", label: "Telefone:", telephone: true }],
        ],
        [
          [{ key: "endereco_cartorio", label: "End.:" }, { key: "cep_cartorio", label: "CEP:", zipCode: true }, { key: "cidade_cartorio", label: "Cidade:" }],
          [{ key: "nr_endereco_cartorio", label: "Nº:" }, { key: "bairro_cartorio", label: "Bairro:" }, { key: "uf_cartorio", label: "UF:" }],
          [{ key: "complemento_cartorio", label: "Complemento:" }],
        ],
      ];
    },
    detailCardFields() {
      var card = {
        regOff: this.setRegOffStructure(),
        requester: this.setRequesterStructure(),
        order: [],
      };

      switch (this.page) {
        case "VisualizarPedidoProtesto":
          card.order = [
            [
              //pedido
              [{ key: "cd_pedido_protesto", label: "Nº Pedido:" }],
              [{ key: "dt_cadastro", label: "Data Cadastro:", isDate: true }],
            ],
            [
              // titulo
              [
                { key: "nm_nosso_numero", label: "Nosso Número:" },
                { key: "nm_nr_titulo", label: "Nº Título:" },
                { key: "vl_titulo", label: "Valor Título:", isCurrency: true },
                { key: "vl_protesto", label: "Valor Protesto:", isCurrency: true },
                { key: "especie", label: "Espécie:" },
              ],
              [
                { key: "nr_cartorio", label: "Nº Cartório:" },
                { key: "nm_nr_protocolo", label: "Protocolo:" },
                { key: "vl_retirada", label: "Valor p/ Retirada:", isCurrency: true },
                { key: "dt_cadastro", label: "Dt. Solicitação:", isDate: true },
                { key: "dt_emissao", label: "Dt. Emissão:", isDate: true },
              ],
              [
                { key: "dt_vencimento", label: "Dt. Vencimento:", isDate: true },
                { key: "decl_portador", label: "Decl. Portador:" },
                { key: "falencia", label: "Falência:" },
                { key: "lei9430", label: "Art. 9A, lei 9430:" },
                { key: "endosso", label: "Endosso:" },
              ],
              [{ key: "aceite", label: "Aceite:" }],
            ],
            [
              // sacador
              [{ key: "nm_sacador", label: "Sacador:" }, { key: "email_sacador", label: "E-mail:" }],
              [{ key: "documento_sacador", label: "Doc. Sacador:", maskDoc: true }, { key: "celular_sacador", label: "Celular:", telephone: true }],
              [{ key: "endereco_sacador", label: "Endereço:" }, { key: "cep_sacador", label: "CEP:", zipCode: true }],
              [{ key: "cidade_sacador", label: "Cidade:" }],
              [{ key: "uf_sacador", label: "UF:" }],
            ],
            [
              // cedente
              [{ key: "nm_cedente", label: "Cedente:" }, { key: "endereco_cedente", label: "Endereço:" }],
              [{ key: "documento_cedente", label: "Doc. Cedente:", maskDoc: true }, { key: "nr_endereco_cedente", label: "Nº:" }],
              [{ key: "cep_cedente", label: "CEP:", zipCode: true }, { key: "compl_cedente", label: "Compl.:" }],
              [{ key: "cidade_cedente", label: "Cidade:" }, { key: "uf_cedente", label: "UF:" }],
            ],
            [
              // devedor
              [{ key: "nm_devedor", label: "Devedor:" }, { key: "celular_devedor", label: "Celular:", telephone: true }],
              [{ key: "documento_devedor", label: "Doc. Devedor:", maskDoc: true }, { key: "endereco_devedor", label: "Endereço:" }],
              [{ key: "email_devedor", label: "E-mail:" }, { key: "nr_endereco_devedor", label: "Nº:" }],
              [{ key: "compl_devedor", label: "Compl.:" }, { key: "cidade_devedor", label: "Cidade:" }],
              [{ key: "cep_devedor", label: "CEP:", zipCode: true }, { key: "uf_devedor", label: "UF:" }],
              [{ key: "bairro_devedor", label: "Bairro:" }],
            ],
          ];
          break;
        case "aprovadas":
          card.order = [
            [
              [{ key: "cd_anuencia", label: "Nº Anuência:" }, { key: "vl_custas", label: "Valor Emol. p/ Canc.:" }],
              [{ key: "dt_cadastro", label: "Dt. Solicitação:", isDate: true }, { key: "nm_chave", label: "Chave Verificação:" }],
              [{ key: "ds_status", label: "Status" }],
            ],
            [
              [
                { key: "nm_devedor", label: "Devedor:" },
                { key: "nm_nosso_numero", label: "Nosso Número:" },
                { key: "nm_nr_titulo", label: "Nº Título:" },
                { key: "dt_emissao", label: "Dt. Emissão:", isDate: true },
              ],
              [
                { key: "documento_devedor", label: "Doc. Devedor:", maskDoc: true },
                { key: "nm_nr_protocolo", label: "Protocolo:" },
                { key: "vl_titulo", label: "Valor Título:", isCurrency: true },
                { key: "dt_vencimento", label: "Dt. Vencimento:", isDate: true },
              ],
              [
                { key: "dt_ocorrencia", label: "Dt. Protesto:", isDate: true },
                { key: "dt_protocolo", label: "Dt. Protocolo:", isDate: true },
                { key: "vl_protesto", label: "Valor Protestado:", isCurrency: true },
              ],
            ],
          ];
          break;
        case "Certidao":
          card.order = [
            [
              [{ key: "cd_pedido", label: "Nº Pedido:" }, { key: "vl_orcamento", label: "Valor Pedido:", isCurrency: true }],
              [{ key: "data_pedido", label: "Dt. Pedido:", isDate: true }, { key: "nm_chave_verificacao", label: "Chave Verificação:" }],
              [{ key: "status_pedido", label: "Status:" }],
            ],
            [
              [
                { key: "nm_pesquisado", label: "Nome Pesq.:" },
                { key: "rg_pedido", label: "RG Pesq.:" },
                { key: "nm_endereco_pesquisado", label: "Endereço:" },
                { key: "nm_cidade_pesquisado", label: "Cidade:" },
              ],
              [
                { key: "nm_email_pesquisado", label: "E-mail:" },
                { key: "motivo_pedido", label: "Motivo da Solicitação:" },
                { key: "nm_bairro_pesquisado", label: "Bairro:" },
                { key: "nm_uf_pesquisado", label: "UF:" },
              ],
              [{ key: "documento_pedido", label: "Doc. Pesq.:", maskDoc: true }, { key: "", label: "" }, { key: "nr_cep_pesquisado", label: "CEP:", zipCode: true }],
            ],
          ];
          break;
        case "Cancelamento":
          card.order = [
            [
              [{ key: "cd_pedido", label: "Nº Pedido:" }, { key: "vl_orcamento", label: "Valor Pedido:", isCurrency: true }],
              [{ key: "data_pedido", label: "Dt. Pedido:", isDate: true }],
              [{ key: "status_pedido", label: "Status:" }],
            ],
            [
              [
                { key: "cd_anuencia", label: "Nº Anuência:" },
                { key: "documento_devedor", label: "Doc. Devedor:", maskDoc: true },
                { key: "nr_titulo", label: "Nº Título:" },
                { key: "vl_titulo", label: "Valor Título:", isCurrency: true },
                { key: "dt_protocolo", label: "Dt. Protocolo:", isDate: true },
              ],
              [
                { key: "data_cadastro_anuencia", label: "Dt. Solicitação:", isDate: true },
                { key: "nm_devedor", label: "Nome Devedor:" },
                { key: "dt_emissao_titulo", label: "Dt. Emissão:", isDate: true },
                { key: "vl_protesto", label: "Valor Protesto:", isCurrency: true },
                { key: "dt_ocorrencia", label: "Dt. Protesto:", isDate: true },
              ],
              [
                { key: "status_anuencia", label: "Status:" },
                { key: "vl_custas_emol", label: "Valor Emol. p/ Cancelamento:", isCurrency: true },
                { key: "dt_venc_titulo", label: "Dt. Vencimento:", isDate: true },
                { key: "nr_protocolo_titulo", label: "Protocolo:" },
              ],
            ],
          ];
          break;
        default:
          break;
      }
      return card;
    },
    executaFuncaoAcoes(acao, row){
      switch (acao.funcao) {
        case 'exibir':
          this.exibir(row);
          break;
        case 'abrirMaisOpcoes':
          this.itemAcao = row;
          this.abrirMaisOpcoes();
          break;
        default:
          this.$emit('chamar-funcao', acao.funcao, row)
          break;
      }
    },
    abrirMaisOpcoes(){
      this.$refs["modalMaisOpcoes"].show();
    },
  },
  mounted() {
    var gridTemplateColumns = "";
    this.colunas.forEach((column) => {
      gridTemplateColumns += " minmax(105px, " + column.size + ")";
    });
    this.tableStyleProperties.style = { "grid-template-columns": gridTemplateColumns, "grid-gap": "15px" };
    switch (this.page) {
      case "Painel":
        this.detailCardBg = this.detailCardBgOptions.azul;
        break;
      case "VisualizarPedidoProtesto":
        this.detailCardBg = this.detailCardBgOptions.azul;
        break;
      case "certidoes":
        this.detailCardBg = this.detailCardBgOptions.verde;
        break;
      default:
        this.detailCardBg = this.detailCardBgOptions.azul;
        break;
    }
  },
  computed: {
    pedidoSelecionado(){
      let pedido = this.itemAcao;
      switch (this.page) {
        case 'VisualizarPedidoProtesto':
          return pedido.cd_pedido_protesto;
        case 'Certidao':
          return pedido.cd_pedido;
        case 'Cancelamento':
          return pedido.cd_pedido;
        case 'aprovadas':
          return pedido.cd_anuencia;
      }
      return 0;
    },
    acoes() {
      let actionsColumn = this.colunas.find(column => column.key === "actions").acoes;
      const tamanhoLinha = 3;
      actionsColumn = actionsColumn.filter(acao => !['abrirMaisOpcoes'].includes(acao.funcao)).filter(acao => this.itemAcao[acao.condicao] == 1 || acao.condicao == 1);
      const acoes = actionsColumn.reduce((acc, item, index) => {
        const parteIndex = Math.floor(index / tamanhoLinha);
        if (!acc[parteIndex]) acc[parteIndex] = [];
        acc[parteIndex].push(item);
        return acc;
      }, []);
      return acoes;
    },
    sortedResult: function() {
      let sortedResult = this.resultado;
      let maisAcoes = 0;
      let acoes = this.colunas.find(column => column.key === "actions").acoes;
      sortedResult.forEach(result => {
        maisAcoes = 0;
        acoes.forEach(acao => {
          if(acao.condicao != 'maisAcoes' && (result[acao.condicao] == 1 || acao.condicao == 1)) maisAcoes++;
        });
        result.maisAcoes = (maisAcoes > 2);
      });
      if (this.sort.key !== "") {
        sortedResult = sortedResult.sort((a, b) => {
          let fa = a[this.sort.key],
            fb = b[this.sort.key];
          if (typeof fa == "string") {
            fa = fa.toLowerCase();
          }
          if (typeof fb == "string") {
            fb = fb.toLowerCase();
          }

          if (fa < fb) {
            return -1;
          }
          if (fa > fb) {
            return 1;
          }
          return 0;
        });
      }
      if (this.sort.sorting == "desc") sortedResult.reverse();
      return sortedResult;
    },
    resultadoHeight: {
      get() {
        return this.offsetHeight;
      },
    },
    resultadoMinHeight: {
      get() {
        let totalRows = this.sortedResult.length;
        let visibleRows = totalRows > 7 ? 8 : totalRows + 1;
        let size = visibleRows * 48;
        if (this.detalheAtivo && visibleRows < 8) size = size + document.getElementById("resultado-detail-card").offsetHeight;

        return size + "px";
      },
    },
    resultadoMarginBottom: {
      get() {
        if (this.sortedResult.length < 7) return (8 - this.sortedResult.length) * 48 + "px";
        else return "0px";
      },
    },
    filterElement: function() {
      return document.getElementById("area-logada-filtro-container");
    },
  },
  watch: {
    exibirDetalhe(newVal, oldVal) {
      if(newVal) {
        if(this.page === 'VisualizarPedidoProtesto') this.$bvModal.show("modal-protesto-detalhe");
        else if (this.page === 'Certidao' ) this.$bvModal.show("modal-certidao-detalhe");
        else if (this.page === 'Cancelamento') this.$bvModal.show("modal-cancelamento-detalhe");
        else if (this.page === 'aprovadas') this.$bvModal.show("modal-anuencia-detalhe");
      }
    }
},
};
</script>
<style>
#modal-mais-opcoes .modal-body .row:not(:last-child) {
  margin-bottom: 30px;
}
#modal-mais-opcoes .modal-mais-opcoes-close{
  cursor: pointer;
  position: absolute;
  right: -51px;
  background: #4780F1;
  width: 45px;
  height: 45px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  /* font-family: "Comfortaa", sans-serif; */
  font-family: 'Kanit', sans-serif;
  font-size: 30px;
  font-weight: 700;
  padding-left: 2px;
  box-shadow: 4px 6px 20px #00000043;
}
#modal-mais-opcoes .card { border: 3px solid #4780f1;border-radius: 25px;cursor: pointer; }
#modal-mais-opcoes .card:hover { background: #4780f1; }
#modal-mais-opcoes .card.disabled { border-color: #555;cursor: default; }
#modal-mais-opcoes .card.disabled:hover { background-color: #888; }
#modal-mais-opcoes .card-body { padding: 12px;}
#modal-mais-opcoes .card-text { height: 100px;overflow: hidden;position:relative; }
#modal-mais-opcoes .card-text span { position: absolute;top: 120px;text-align: left;font: normal normal bold 15px/16px 'Kanit', sans-serif;letter-spacing: 0px;opacity: 0;color:#4780f1; }
#modal-mais-opcoes .card-text svg { cursor: pointer;font-size: 54px;position: absolute;top: 22px;opacity: 1; }
#modal-mais-opcoes .card-body:hover span { top: 40px;opacity: 1;color: #FFF; }
#modal-mais-opcoes .card-body:hover svg { top: -120px;opacity: 0;color: #fff !important; }
#modal-mais-opcoes .card-text svg,
#modal-mais-opcoes .card-text span { transition: top 0.52s, opacity 0.52s; }
#modal-mais-opcoes .card.disabled svg,
#modal-mais-opcoes .card.disabled span {color:#555 !important;}
.area-logada-resultado-container {
  width: 100%;
  height: 100%;
  height: fit-content;
  display: flex;
  flex-flow: column;
  overflow-x: auto;
}
.area-logada-resultado-container::-webkit-scrollbar {
  width: 17px;
}
.area-logada-resultado-container::-webkit-scrollbar-track {
  background: transparent;
}
.area-logada-resultado-container::-webkit-scrollbar-thumb {
  background-color: #707070;
  border-left: 18px solid transparent;
  border-right: 18px solid transparent;
  background-clip: padding-box;
  border-radius: 27200px;
  border-bottom: 7.5px solid transparent;
  border-top: 7.5px solid transparent;
}
.table-resultado-header,
.table-resultado-body {
  min-width: 100%;
  display: grid;
  grid-template-rows: auto;
  overflow-y: overlay;
  overflow-x: hidden;
  width: fit-content;
}
.table-resultado-body {
  max-height: calc(100% - 48px);
}
.table-resultado-body::-webkit-scrollbar {
  width: 17px;
}
.table-resultado-body::-webkit-scrollbar-track {
  background: transparent;
}
/* .table-resultado-body::-webkit-scrollbar-thumb{background-color: #707070;border-left: 7px solid transparent;border-right: 7px solid transparent;background-clip: padding-box;border-radius: 20px;} */
.table-resultado-body::-webkit-scrollbar-thumb {
  background-color: #707070;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  background-clip: padding-box;
  border-radius: 72px;
  border-bottom: 8px solid transparent;
  border-top: 8px solid transparent;
}
.table-resultado-row {
  grid-column: span 8;
  grid-auto-flow: column;
  display: grid;
  grid-template-columns: repeat(8, 1fr);
}
.table-resultado-column {
  height: 48px;
}
.table-resultado-column:first-child {
  padding-left: 20px;
}
.table-resultado-column:last-child {
  padding-right: 20px;
}
.table-resultado-body .table-resultado-column span {
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.table-resultado-body .table-resultado-column span .table-resultado-column-infolet {
  display: none;
  width: fit-content;
  height: fit-content;
  border: 2px solid #f2af1d;
  background-color: #fdf1d5;
  position: absolute;
  padding: 2px 6px;
  margin-top: -54px;
  margin-left: -8px;
}
.table-resultado-body .table-resultado-column span:hover .table-resultado-column-infolet {
  width: fit-content;
  display: flex;
}
.table-resultado-row .table-resultado-column {
  height: 48px;
  font: normal normal 200 16px/20px 'Kanit', sans-serif;
  letter-spacing: -1%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: center;
}
.table-resultado-header {
  color: white;
  font-weight: bold;
  background-color: var(--primary-color);
}
.table-resultado-header .table-resultado-column {
  display: flex;
  align-items: center;
}
.table-resultado-header .table-resultado-column > * {
  font-size: 16px;
  line-height: 20px;
  font-family: 'Kanit', sans-serif;
  letter-spacing: -1%;
  font-weight: 300;
}
.table-resultado-body .table-resultado-row .table-resultado-column {
  color: var(--secondary-color);
}
.table-resultado-body .table-resultado-row:nth-child(even) {
  background-color: #ffffff;
}
.table-resultado-body .table-resultado-row:nth-child(odd) {
  background-color: #f1f1f1;
}
.table-resultado-sort {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
}
.sort-icons {
  width: 10px;
  height: 15px;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  align-items: center;
  margin-right: 13px;
}
.sort-icons::before {
  content: "";
  border-bottom: 5px solid #00000060;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
}
.sort-icons::after {
  content: "";
  border-top: 5px solid #00000060;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
}
.table-resultado-sort.sort-asc .sort-icons::before {
  border-bottom: 5px solid white;
}
.table-resultado-sort.sort-desc .sort-icons::after {
  border-top: 5px solid white;
}

.table-resultado-body .table-resultado-row .table-resultado-detail.btn-details {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 3px solid #4780f1;
  border-radius: 5px;
  text-align: center;
  font: normal normal normal 15px/20px 'Kanit', sans-serif;
  letter-spacing: 0px;
  color: #4780f1;
  cursor: pointer;
  width: 85px;
  min-width: 85px;
  height: 34px;
  user-select: none;
}
.table-resultado-body .table-resultado-row .table-resultado-detail.btn-details:hover,
.table-resultado-body .table-resultado-row.active .table-resultado-detail.btn-details {
  background: #4780f1;
  color: white;
}

.table-resultado-body .table-resultado-row .table-resultado-detail.container-actions {
  display: flex;
  align-items: center;
  height: 20px;
  width: 76px;
  flex-wrap: wrap;
  gap: 0px 12.5px;
}
.table-resultado-body .table-resultado-row .table-resultado-detail.container-actions .action-item {
  width: 20px;
  height: 20px;
}
.table-resultado-body .table-resultado-row .table-resultado-detail.container-actions .action-item.bg-fill {
  background-color: #7a7a7a;
  border-radius: 100%;
}
.table-resultado-body .table-resultado-row .table-resultado-detail.container-actions .action-item > * {
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #7a7a7a;
}
.table-resultado-body .table-resultado-row .table-resultado-detail.container-actions .action-item.bg-fill > * {
  color: white;
}
.table-resultado-body .table-resultado-row.active .table-resultado-detail.container-actions .action-item.item-show > *,
.table-resultado-body .table-resultado-row .table-resultado-detail.container-actions .action-item > *:hover {
  color: #597eb5;
}
.table-resultado-body .table-resultado-row .table-resultado-detail.container-actions .action-item.bg-fill > *:hover {
  color: white;
  background-color: #597eb5;
  border-radius: 100%;
}
.recibo-icon {
  background-image: url("~@/assets/imgs/recibo-cinza.png");
  cursor: pointer;
  background-size: contain;
  background-repeat: no-repeat;
}
.recibo-icon:hover {
  background-image: url("~@/assets/imgs/recibo-azul.png");
  filter: saturate(4) brightness(0.6);
}

.table-resultado-body .table-resultado-row .table-resultado-detail.container-actions svg{
    height: 28px !important;
    width: 28px !important;
    margin: 0px !important;
}

.table-resultado-body .table-resultado-row .table-resultado-detail.container-actions {
  /* display: flex;
  flex-wrap: wrap;
  margin-top: 8px; Adiciona uma margem superior entre as linhas de botões */
}

.table-resultado-body .table-resultado-row .table-resultado-detail.container-actions .action-item {
  flex: 0 0 calc(33.33% - 8px); /* Define cada botão para ocupar cerca de 33.33% da largura da linha, descontando a margem */
  max-width: calc(33.33% - 8px); /* Define a largura máxima de cada botão para cerca de 33.33% da largura da linha, descontando a margem */
  margin-right: 8px; /* Adiciona um espaço entre os botões */
  margin-bottom: 8px; /* Adiciona um espaço entre as linhas de botões */
}

/* Para quebrar para uma nova linha após o terceiro botão */
.table-resultado-body .table-resultado-row .table-resultado-detail.container-actions .action-item:nth-child(3n) {
  margin-right: 0; /* Remove a margem direita do terceiro botão para que ele se alinhe à borda direita */
}

/* Se houver menos de três botões, garantir que a linha termine corretamente */
.table-resultado-body .table-resultado-row .table-resultado-detail.container-actions .action-item:nth-last-child(-n + 3) {
  margin-right: auto; /* Define a margem direita automática para o último botão na linha */
}
</style>
